import api from './axios';

export const listar   = (params) => api.get('/demandas-fabricacao/', { params });
export const buscarId = (id)     => api.get(`/demandas-fabricacao/${id}`);

export const iniciarProducao = (id, data_prevista_entrega) =>
  api.post(`/demandas-fabricacao/${id}/iniciar-producao`, { data_prevista_entrega: data_prevista_entrega || null });

export const atualizarPrevisao = (id, data_prevista_entrega) =>
  api.patch(`/demandas-fabricacao/${id}/previsao`, { data_prevista_entrega });
